import { isNil } from 'lodash';
import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { AppID } from '@playq/octopus-common';
import { GenericFailure } from '@playq/services-shared';
import { AppBillingResponse } from '@playq/services-taxman';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const corpQueryBillingByAppQueryKeys: unknown[] = ['corp', 'query', 'billing', 'by app', 'query'];

export const useQueryBillingByAppQuery = (
  from: Date,
  till: Date,
  appID?: AppID,
  options?: IUseQueryOptionsExtended<AppBillingResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => corpQueryBillingByAppQueryKeys.concat(from, till, appID), [from, till, appID]);
  return useEitherQuery(
    keys,
    () => {
      if (!isNil(appID)) {
        return services2.queryBillingService.queryByApp(from, till, appID);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
};
